/*!
 * @Author: leo
 * @Date: 2019-12-25 20:55:00
 * @Last Modified by: leo
 * @Last Modified time: 2019-12-25 20:55:00
 * @Instruduction: 文件服务接口
 */

import xhr from './xhr/index'

class FileService {
    /** 获取图片上传 token */
    public async getToken() {
        const result = await xhr({
            method: 'get',
            url: '/file/upload_token',
            params: null
        })
        return result
    }
}

// 实例化后导出，全局单例
export default new FileService()
